module.exports = __webpack_public_path__ + "img/Group 1350@2x.cb274345.png";